module.exports = __webpack_public_path__ + "img/radar-integration.bf1238d0.png";